import React from 'react';
import { CommonHash } from 'app/types';
import Text from 'common/components/Text/Text';

import styles from '../LandingForm.module.scss';
import SubLandingComponentForm from '../SubLandingComponentForm';

interface ComponentFormProps {
  landing_cmp: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  index: number;
}

const FAQSectionForm = ({
  landing_cmp,
  handleChange,
  index,
}: ComponentFormProps): React.ReactElement => {
  return (
    <>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['title']`}>Title</label>
        <input
          name={`landing_components[${index}].config['title']`}
          placeholder="Title"
          onChange={handleChange}
          defaultValue={landing_cmp.config.title || ''}
        />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['title_size']`}>Title size</label>
        <select
          name={`landing_components[${index}].config['title_size']`}
          onChange={handleChange}
          value={landing_cmp.config ? landing_cmp.config['title_size'] : 'normal'}
        >
          <option value="large">Large</option>
          <option value="normal">Normal</option>
          <option value="small">Small</option>
        </select>
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['section_title']`}>
          Section title
        </label>
        <input
          name={`landing_components[${index}].config['section_title']`}
          placeholder="Section title"
          onChange={handleChange}
          defaultValue={landing_cmp.config.section_title || ''}
        />
      </div>
      <Text size={22} weight={600} inlineStyle={{ marginTop: '20px', marginBottom: '10px' }}>
        FAQs
      </Text>
      <SubLandingComponentForm
        name={`landing_components[${index}].sub_landing_components`}
        landing_component={landing_cmp}
        handleChange={handleChange}
        limit={100}
        sub_component={'faq'}
        component_name="FAQ"
      />
    </>
  );
};

export default FAQSectionForm;
